module.exports = __webpack_public_path__ + "img/totalQues.dc6fa8c2.svg";